import React from 'react';
import {
  destinazioneHeadline,
  luogoZonaValue,
  indirizzoGpsValue,
  telefonoDestValue,
  destKeySmistamento,
  smistamentoFormatQuantitaCell,
  smistamentoEquivalentePlanning,
  formatGiornoSmistamentoIt,
} from '../utils/smistamentoHelpers';
import './SmistamentoPrintView.css';

function isDestinazioneCompletata(d) {
  return (
    d.completed === true ||
    d.completed === 1 ||
    d.completed === '1' ||
    d.completed === 'true'
  );
}

/**
 * Layout per stampa (lista già filtrata e ordinata come a schermo).
 * Visibilità gestita da SmistamentoPrintView.css (@media screen / print).
 */
function SmistamentoPrintView({
  destinazioni,
  ordinaPerLuogoZona,
  giornoEsatto,
  filterDescrizione,
  filterClienteDest,
  filterLuogoZona,
  titoloPanificio,
}) {
  const list = Array.isArray(destinazioni) ? destinazioni : [];
  const filtriParts = [];
  if (String(filterClienteDest || '').trim())
    filtriParts.push(`Cliente/destinazione: ${String(filterClienteDest).trim()}`);
  if (String(filterDescrizione || '').trim())
    filtriParts.push(`Articolo: ${String(filterDescrizione).trim()}`);
  if (String(filterLuogoZona || '').trim())
    filtriParts.push(`Zona: ${String(filterLuogoZona).trim()}`);
  if (ordinaPerLuogoZona) filtriParts.push('Ordinamento: per luogo zona');

  const nodes = [];
  let prevZonaNorm = null;

  list.forEach((d) => {
    const key = destKeySmistamento(d);
    const headline = destinazioneHeadline(d);
    const indirizzo = indirizzoGpsValue(d);
    const telefono = telefonoDestValue(d);
    const righe = Array.isArray(d.righe) ? d.righe : [];
    const zona = luogoZonaValue(d);
    const zonaNorm = zona || '__senza_zona__';

    if (ordinaPerLuogoZona && zonaNorm !== prevZonaNorm) {
      prevZonaNorm = zonaNorm;
      const label = zona || 'Senza zona';
      nodes.push(
        <div key={`p-z-${zonaNorm}-${key}`} className="smistamento-print-zona-bar">
          Codice zona: {label}
        </div>
      );
    }

    nodes.push(
      <section key={key} className="smistamento-print-block">
        <h2 className="smistamento-print-dest-title">{headline}</h2>
        {indirizzo ? <p className="smistamento-print-sub">{indirizzo}</p> : null}
        {telefono ? <p className="smistamento-print-sub">Tel. {telefono}</p> : null}
        <p className="smistamento-print-status">
          Stato: {isDestinazioneCompletata(d) ? 'Completato' : 'Da completare'}
        </p>
        <table className="smistamento-print-table">
          <colgroup>
            <col className="col-desc" />
            <col className="col-um" />
            <col className="col-qta" />
            <col className="col-corr" />
          </colgroup>
          <thead>
            <tr>
              <th>Descrizione</th>
              <th>U.M.</th>
              <th>Quantità</th>
              <th>Corrispondente</th>
            </tr>
          </thead>
          <tbody>
            {righe.length === 0 ? (
              <tr>
                <td colSpan={4} style={{ textAlign: 'center' }}>
                  Nessuna riga articolo
                </td>
              </tr>
            ) : (
              righe.map((r, idx) => (
                <tr key={`${key}-r-${idx}`}>
                  <td>{r.descriz || r.descrizione || '—'}</td>
                  <td>{r.unita_m || r.unita_di_misura || '—'}</td>
                  <td>{smistamentoFormatQuantitaCell(r.quantita ?? r.quantita_totale)}</td>
                  <td>{smistamentoEquivalentePlanning(r)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </section>
    );
  });

  return (
    <div className="smistamento-print-root">
      <header className="smistamento-print-header">
        <h1 className="smistamento-print-title">Smistamento</h1>
        {titoloPanificio ? <p className="smistamento-print-meta">Panificio: {titoloPanificio}</p> : null}
        <p className="smistamento-print-meta">Giorno: {formatGiornoSmistamentoIt(giornoEsatto)}</p>
        <p className="smistamento-print-meta">
          Elenco destinazioni: {list.length} {list.length === 1 ? 'voce' : 'voci'}
        </p>
      </header>

      {filtriParts.length > 0 ? (
        <section className="smistamento-print-filters">
          <strong>Filtri attivi</strong>
          <ul className="mb-0 mt-1 ps-3">
            {filtriParts.map((t) => (
              <li key={t}>{t}</li>
            ))}
          </ul>
        </section>
      ) : null}

      {list.length === 0 ? <p>Nessuna destinazione nell&apos;elenco corrente.</p> : nodes}
    </div>
  );
}

export default SmistamentoPrintView;
